import { CloseOutlineIcon } from '@carboncopyco/icons';
import { Button, Dialog, TextBase, TextSectionHeader } from '@carboncopyco/ui';

interface ScreenCaptureModalProps {
  onAccept: () => void;
  onDecline: () => void;
  onClose: () => void;
}

const ScreenPermissionModal = ({
  onAccept,
  onDecline,
  onClose,
}: ScreenCaptureModalProps) => {
  const DialogHeader = (
    <div className="pb-5 flex justify-between items-center">
      <TextSectionHeader
        label="Allow screen capture"
        color="text-ds-natural-600"
      />
      <div
        onClick={onClose}
        className="h-full flex justify-between items-center cursor-pointer"
      >
        <CloseOutlineIcon color="rgba(155, 154, 162, 1)" />
      </div>
    </div>
  );

  const DialogFooter = (
    <div className="pt-6 flex justify-end items-center gap-2.5">
      <Button
        label="Don't allow"
        onClick={onDecline}
        link
        dark
      />
      <Button
        label="Allow"
        onClick={onAccept}
      />
    </div>
  );

  return (
    <Dialog
      width={500}
      header={DialogHeader}
      footer={DialogFooter}
      onClose={onClose}
      dialogStyle={{
        position: 'absolute',
        top: '70px',
        left: '50%',
        transform: 'translate(-50%, 0)',
        zIndex: 99,
      }}
    >
      <div className="flex flex-col gap-4">
        <TextBase
          color="text-ds-natural-600"
          label="Use the native screen capture capability of your computer to
            increase clone accuracy and improve support."
        />
        <TextBase
          color="text-ds-natural-600"
          label='Click "Allow" to grant access, a prompt will be presented.'
        />
      </div>
    </Dialog>
  );
};

export default ScreenPermissionModal;
